export const ADMIN_ROLE = "ADMIN";
export const ADMIN_OFFICE_ROLE = "OFFADMIN";
export const TELLER = "TELLER";
export const OFFINSUPERVISOR = "OFFINSUPERVISOR";
export const OFFEXSUPERVISOR = "OFFEXSUPERVISOR";
export const INBIOCOLLECTOR = "INBIOCOLLECTOR";